import React, { useState, useEffect } from "react";
import "./Service.css";
// import { useFadeInOnScroll } from "../Animations/fadein";
// import WOW from 'wowjs';
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';

const servicesData = [
    {
        icon: "/assets/service-icons/icon-1.png",
        hoverIcon: '/assets/service-icons/icon-1-hover.png',
        title: "Brake Repair",
        description:
            "You get used to your brakes. Brake pads and rotors wear out from the immense friction and heat they encounter. Air gets into brake lines...",
    },
    {
        icon: "/assets/service-icons/icon-2.png",
        hoverIcon: '/assets/service-icons/icon-2-hover.png',
        title: "Engine Repair",
        description:
            "The check engine usually indicates a need to replace one or more parts of your engine or exhaust system: the oxygen sensor, catalytic converter, mass...",
    },
    {
        icon: "/assets/service-icons/icon-3.png",
        hoverIcon: '/assets/service-icons/icon-3-hover.png',
        title: "Tire Repair",
        description:
            "You need new tires, and you have questions. What type of tire do I really need? What do terms like 'all-season' and 'all-terrain' really mean?...",
    },
    {
        icon: "/assets/service-icons/icon-4.png",
        hoverIcon: '/assets/service-icons/icon-4-hover.png',
        title: "Cooling System",
        description:
            "An overheated engine that leaves you stranded on the side of the road is a hassle. But overheating is one of many signs of trouble...",
    },
    {
        icon: "/assets/service-icons/icon-5.png",
        hoverIcon: '/assets/service-icons/icon-5-hover.png',
        title: "Battery Repair",
        description:
            "Your vehicle just won't start. You turn on the ignition, and all you get is the metallic clicking noise. Possibly followed by competing pronouncements of...",
    },
    {
        icon: "/assets/service-icons/icon-6.png",
        hoverIcon: '/assets/service-icons/icon-6-hover.png',
        title: "Steering Repair",
        description:
            "Your steering and suspension systems work together to keep your tires on the pavement and your vehicle under control – until a power steering problem...",
    },
];

const Services = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.5,
                ease: 'easeOut',
            },
        }),
    };
    const words = ['OUR', 'SERVICES'];
    // const fadeProps = useFadeInOnScroll("0.1s");
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null)

    useEffect(() => {
        // Replace with your API endpoint
        const fetchData = async () => {
            try {
                const response = await fetch('https://admin.ezerautomotive.co.nz/api/services/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setData(result);
                console.log(result, "result")
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    console.log(data, "services")

    return (
        <section className="services">
            <div className="services-header ">
                <h2 className="chakra-petch-bold ">
                    {/* <span 
                    // {...fadeProps}
                    >OUR</span>
                    <span 
                    // {...useFadeInOnScroll("0.2s")}
                    > SERVICES</span> */}
                    {words.map((word, i) => (
                        <motion.span
                            key={i}
                            custom={i}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={fadeInUp}
                            style={{ display: 'inline-block', marginRight: '0.5rem' }}
                        >
                            {word}
                        </motion.span>
                    ))}
                </h2>
                <button className="all-services-btn chakra-petch-semibold">ALL SERVICES</button>
            </div>
            <div className="services-grid">
                {data.map((service, index) => (
                    <div className="service-card" key={index}>
                        <div className="service-icon">
                            <img src={service.icon} alt={service.name} className="icon default-icon" />
                            <img src={service.icon} alt={service.name} className="icon hover-icon" />
                        </div>
                        <h3 className="chakra-petch-semibold">{service.name}</h3>
                        <p className="font-mulish" >{service.short_description}</p>
                        <a href="#" className="details-link">
                            <span className="icon-box">{'>'}</span>
                            <span className="link-text chakra-petch-semibold" onClick={() => navigate(`/service/${service.name}`)}
                            >DETAILS SERVICE</span>
                        </a>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;
